<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo" to="/">
        <img src="/logo.png" height="30" alt="همکده">
        <h2 class="brand-text text-primary ml-1">
          {{ $t('App.title') }}
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
          lg="4"
          class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
            sm="8"
            md="6"
            lg="12"
            class="px-xl-2 mx-auto"
            v-if="forgetPage"
        >
          <b-card-title class="mb-1">
            فراموشی رمز عبور 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            برای دریافت کد تأیید نام کاربری خود را وارد نمایید.
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
                class="auth-forgot-password-form mt-2"
                @submit.prevent="validationForm"
            >
              <b-form-group
                  label="نام کاربری"
                  label-for="forgot-password-username"
              >
                <validation-provider
                    #default="{ errors }"
                    name="نام کاربری"
                    rules="required"
                >
                  <b-form-input
                      id="forgot-password-username"
                      v-model="username"
                      :state="errors.length > 0 ? false:null"
                      name="forgot-password-username"
                      placeholder="نام کاربری خود را وارد نمایید"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-button
                  variant="primary"
                  block
                  :disabled="onProgress"
                  @click="forgotPassword('sms')"
              >
                <feather-icon
                    icon="MailIcon"
                    class="mr-50"
                />
                <span class="align-middle">{{ onProgress ? 'در حال ارسال اطلاعات' : 'ورود با پیامک' }}</span>
              </b-button>

              <b-button
                  type="button"
                  variant="danger"
                  block
                  :disabled="onProgress"
                  @click="forgotPassword('call')"
              >
                <feather-icon
                    icon="PhoneCallIcon"
                    class="mr-50"
                />
                <span class="align-middle">{{ onProgress ? 'در حال ارسال اطلاعات' : 'ورود از طریق تماس' }}</span>

              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronRightIcon"/>
              بازگشت به صفحه ورود
            </b-link>
          </p>
        </b-col>
        <b-col
            sm="8"
            md="6"
            lg="12"
            class="px-xl-2 mx-auto"
            v-else
        >

          <b-card-text class="mb-2">
            برای ورود کد ارسالی به شماره موبایل خود را وارد نمایید.
          </b-card-text>

          <!-- form -->
          <validation-observer
              ref="otpForm"
          >
            <b-form
                class="auth-login-form mt-2"
                @submit.prevent="checkOtp"
            >
              <b-form-group
                  label="کد ورود"
                  label-for="login-otp"
              >
                <validation-provider
                    #default="{ errors }"
                    name="کد ورود"
                    vid="otp"
                    rules="required"
                >
                  <b-form-input
                      id="login-otp"
                      v-model="otp"
                      :state="errors.length > 0 ? false:null"
                      name="otp"
                      placeholder="کد ورود را وارد نمایید"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-row>
                <b-col>

                  <b-alert
                      v-height-fade.appear
                      variant="info"
                      :show="counting"
                  >
                    <div class="alert-body" v-html="sendAgainText">
                    </div>
                  </b-alert>
                  <b-alert
                      v-height-fade.appear
                      variant="info"
                      :show="!counting"
                  >
                    <div class="alert-body row">

                      <div class="col-12 col-sm-6">
                        ارسال مجدد کد تایید

                      </div>
                      <div class="col-12 col-sm-6">
                        <b-button @click='sendAgain("sms")' v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm"
                                  variant="primary" class="mx-1"
                        >
                          پیامک شود
                        </b-button>
                        <b-button @click='sendAgain("call")' v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm"
                                  variant="danger"
                        >
                          تماس بگیر
                        </b-button>
                      </div>


                    </div>
                  </b-alert>
                </b-col>
              </b-row>

              <!-- submit buttons -->
              <b-button
                  type="submit"
                  variant="primary"
                  block
                  :disabled="onProgress"
              >
                {{ onProgress ? 'در حال ارسال اطلاعات' : 'تأیید کد ورود' }}
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>

      </b-col>
      <b-col
          lg="8"
          class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
              fluid
              :src="imgUrl"
              alt="Forgot password V2"
          />
        </div>
      </b-col>

      <!-- /Left Text-->

      <!-- Forgot password-->
      <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton, BAlert, VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
    'height-fade': heightFade,
  },
  components: {
    BAlert,
    VuexyLogo,
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      username: '',
      forgetPage: true,
      otp: '',
      counting: false,
      countdown: 60,
      sendType: 'sms',
      sideImg: require('@/assets/images/pages/forgot-password-v2.svg'),
      // validation
      required,
      onProgress: false,

    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/forgot-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
    sendAgainText() {
      return this.counting ?
          `<span>ارسال مجدد کد ورود <strong> ${this.countdown} </strong>  ثانیه دیگر</span>` : ''

    },
  },
  methods: {
    forgotPassword(sendType) {
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {
              this.$http.post('auth/forgot-password', {
                username: this.username,
                send_type: sendType
              })
                  .then(({ data }) => {
                    if (data.status) {
                      this.forgetPage = false
                      this.startCountdown()
                    } else {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'ورود ناموفق',
                          icon: 'CoffeeIcon',
                          variant: 'danger',
                          text: data.message,
                        },
                      })
                    }
                  })
                  .catch(error => {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-left',
                      props: {
                        title: 'ورود ناموفق',
                        icon: 'CoffeeIcon',
                        variant: 'danger',
                        text: error?.response?.data?.message ?? error.message,
                      },
                    })
                  })
                  .finally(() => {
                    this.onProgress = false
                  })
            }
          })
    },
    checkOtp() {
      this.$refs.otpForm.validate()
          .then(success => {
            if (success) {
              this.onProgress = true
              this.$http.post('auth/check-forgot-otp', {
                username: this.username,
                otp: this.otp
              })
                  .then(({ data }) => {
                    if (data.status) {
                      this.$store.commit('user/UPDATE_USER_DATA', data.user)
                      this.$router.replace('/').catch(()=>{})
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `${data.user.name} عزیز ، خوش آمدید`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: `شما با موفقیت وارد سیستم شدید`,
                        },
                      })
                    } else {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'ورود ناموفق',
                          icon: 'CoffeeIcon',
                          variant: 'danger',
                          text: data.message ?? 'مشکلی در انجام عملیات رخ داده است',
                        },
                      })
                    }
                  })
                  .catch(error => {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-left',
                      props: {
                        title: 'ورود ناموفق',
                        icon: 'CoffeeIcon',
                        variant: 'danger',
                        text: error?.response?.data?.message ?? error.message,
                      },
                    })
                  })
                  .finally(() => {
                    this.onProgress = false
                  })
            }
          })
    },
    sendAgain(sendType) {
      this.$http.post('auth/forgot-password', {
        username: this.username,
        send_type: sendType
      })
          .then(({ data }) => {
            if (data.status) {
              this.startCountdown()
            }
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-left',
              props: {
                title: 'ورود ناموفق',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: error?.response?.data?.message ?? error.message,
              },
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },
    startCountdown() {
      this.counting = true

      const intervalId = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(intervalId)
          this.countdown = 60
          this.counting = false
        }
      }, 1000)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
